import { Context, useContext } from 'react';

export function useNullableContext<T>(ctx: Context<T | null>): T | null;

export function useNullableContext<T>(
  ctx: Context<T | null>,
  errorMsg: string,
): T;

export function useNullableContext<T>(
  ctx: Context<T | null>,
  errorMsg?: string,
): T | null {
  const value = useContext(ctx);

  if (errorMsg && value === null) {
    throw new Error(errorMsg);
  }

  return value;
}
